<template>
  <b-row>
    <b-col>
      <md-progress-bar md-mode="indeterminate" v-if="loadingProperty"></md-progress-bar>
      <b-row class="mb-3 mt-3" v-else>
        <b-col>
          <md-list v-if="loadedProperty">
            <md-list-item >
              <md-icon>bookmarks</md-icon>
              <div class="md-list-item-text" >
                <moow-button
                  :type="['link', 'blue']"
                  :btnText="loadedProperty.marketingDet.shortDesc"
                  @mClick="openPropertyPreview"
                  :tooltip="loadedProperty.marketingDet.shortDesc"
                  trailingIcon="launch"
                />
                <!-- <a class="moow-link-button-simple" @click="openPropertyPreview">{{loadedProperty.marketingDet.shortDesc}}</a>
                <md-tooltip md-direction="bottom">{{loadedProperty.marketingDet.shortDesc}}</md-tooltip> -->
              </div>
            </md-list-item>

            <md-list-item>
              <md-icon>location_on</md-icon>
              <div class="md-list-item-text">
                <span>{{getDisplayAddress(loadedProperty.location.address)}}</span>
                <md-tooltip
                  md-direction="bottom"
                >{{getDisplayAddress(loadedProperty.location.address)}}</md-tooltip>
                <p
                  class="clickable"
                  v-if="loadedProperty.location.geoCoords && loadedProperty.location.geoCoords.length > 0"
                  @click="openMap(loadedProperty.location.geoCoords[0])"
                >Show on map</p>
              </div>
            </md-list-item>
            <md-list-item>
              <md-icon>account_balance</md-icon>
              <div class="md-list-item-text">
                <span>{{loadedProperty.genDet.propType.superType| capitalize}}</span>
              </div>
            </md-list-item>
            <md-list-item>
              <md-icon>hotel</md-icon>
              <div class="md-list-item-text">
                <span>{{loadedProperty.techDet.nrOfRooms}} rooms</span>
              </div>
            </md-list-item>
            <md-list-item class="md-inset" v-if="loadedProperty.techDet.nrOfBedrooms">
              <div class="md-list-item-text">
                <span>{{loadedProperty.techDet.nrOfBedrooms}} BR</span>
              </div>
            </md-list-item>

            <!-- <moow-button
              :type="['dark', 'outlined', 'flat']"
              btnText="See More"
              icon="launch"
              @mClick="openPropertyPreview"
            /> -->
          </md-list>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import { getListingPublic } from "@/listings/repository/listingRepository.js";
export default {
  props: {
    maaklerID: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      loadingProperty: true,
      loadedProperty: undefined,
    };
  },
  watch: {
    maaklerID: function (val, oldVal) {
      if (val && val != oldVal) this.getProperty(val);
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  computed: {},
  created() {
    this.maaklerID ? this.getProperty(this.maaklerID) : void 0;
  },
  methods: {
    openPropertyPreview() {
      window.open("/#/listing/" + this.maaklerID, "_blank"); // open in new windoe

      // this.$router.push({
      //   name: 'listing',
      //   params: {
      //     listingId: this.maaklerID
      //   }
      // })
    },
    openMap(gc) {
      var url =
        "https://www.google.com/maps/search/?api=1&query=" +
        gc.lat +
        "," +
        gc.lng;
      window.open(url, "_blank");
    },
    getProperty(maaklerID) {
      this.loadingProperty = true;
      getListingPublic(maaklerID)
        .then((property) => {
          this.loadedProperty = property;
          this.$store.commit('UPDATE_FEES', property.fees || {});
        })
        .catch((err) => {})
        .finally((f) => {
          this.loadingProperty = false;
        });
    },
    getDisplayAddress(propAddress) {
      if (!propAddress) return "Unknown";
      var res = "";
      propAddress.municipality
        ? (res += propAddress.municipality + ", ")
        : void 0;
      propAddress.street ? (res += propAddress.street + " ") : void 0;
      propAddress.number ? (res += propAddress.number + " ") : void 0;
      propAddress.apartNumber
        ? (res += "- " + propAddress.apartNumber)
        : void 0;
      return res;
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/listing-preview.css";
</style>



// WEBPACK FOOTER //
// src/components/property/propertySummary.vue